export default __webpack_public_path__ + "static/media/fb.155e62a5.jpg";